import { render, staticRenderFns } from "./web_zcxs.vue?vue&type=template&id=7c4bc70e&scoped=true"
import script from "./web_zcxs.vue?vue&type=script&lang=js"
export * from "./web_zcxs.vue?vue&type=script&lang=js"
import style0 from "./web_zcxs.vue?vue&type=style&index=0&id=7c4bc70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4bc70e",
  null
  
)

export default component.exports